export default "__VITE_ASSET__BMaihwyL__"